import { ErrorMessage } from '@client/new/components/Label';
import { Option } from '@client/new/helpers/types';
import { Col, Row } from '@design-system/components/grid/grid';
import { Typography } from '@design-system/components/typography/typography';
import { fontFamily, space } from '@design-system/tokens';
import { bgColorsVars } from '@design-system/vars.css';
import { MenuItem, Select } from '@mui/material';
import { forwardRef } from 'react';

export type SelectProps<T> = {
  options: Array<Option<string>>;
  value?: T | null;
  name: string;
  onChange: (v: React.ChangeEvent<HTMLInputElement>) => void;
  error?: string;
  width?: number;
  label?: string;
};

export const MenuSelect = forwardRef<
  HTMLDivElement,
  SelectProps<string | number> &
    React.DetailedHTMLProps<
      React.InputHTMLAttributes<HTMLInputElement>,
      HTMLInputElement
    >
>(({ error, width, label, ...p }, ref) => (
  <Col style={{ gap: 0, ...(width ? { width: width + 'px' } : {}) }}>
    {label && (
      <Typography
        variant="body"
        size="medium"
        fontWeight="medium"
        style={{ marginBottom: space.s }}
      >
        {label}
      </Typography>
    )}
    <Row gap="s">
      <Select
        error={!!error}
        ref={ref}
        displayEmpty
        value={p.value ?? ''}
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        onChange={(e) => p.onChange(e as any)}
        renderValue={(value: string | number | null) =>
          value ? p.options.find((i) => i.value === value)?.label : 'Select'
        }
        sx={{
          width: '100%',
          height: '40px',
          borderWidth: '2px',
          marginTop: '1px',
          fontFamily: fontFamily.visuelt,
          borderRadius: '10px',
          boxShadow: 'none !important',

          borderColor: error ? bgColorsVars['ERROR-100'] : '#e4e4e4',
          '&.Mui-error': {
            fontFamily: fontFamily.visuelt,
            borderColor: bgColorsVars['ERROR-100'],
          },
        }}
      >
        {p.options.map(({ value, label }, i) => (
          <MenuItem key={i} value={value}>
            {label}
          </MenuItem>
        ))}
      </Select>
    </Row>
    {error ? (
      <div style={{ marginTop: 8 }}>
        <ErrorMessage content={error} />
      </div>
    ) : null}
  </Col>
));
